const styles = (theme) => ({
  avatar: {
    [theme.breakpoints.down('md')]: {
      width: '64px',
      height: '64px',
    },
  },
  avatarContainer: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(5),
    },
  },
  profileSideContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(9),
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius,
  },
  divider: {
    margin: theme.spacing(6, 0),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(4, 0),
    },
  },
});

export default styles;
